"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTrustedLoginChallengeSession = void 0;
const fetchTrustedLoginChallengeSession = (api, progressId) => api.GET(`${window.MIDDLEWARE_AUTH_BASE_HOST}/authorization/trusted/verify`, {
    headers: {
        progressId,
    },
});
exports.fetchTrustedLoginChallengeSession = fetchTrustedLoginChallengeSession;
//# sourceMappingURL=resolver.js.map